// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"bcb9a424","392":"bcb9a424","583":"82b3cc0f","593":"88be130e","760":"f237c868","866":"e1c92a38"}[chunkId] + ".chunk.css";
};